import { Form } from 'react-bootstrap';
import { AddEditProps, FiscalDevice, FiscalDeviceDTO, User } from '../models/table-models';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import CommonInputText from '../components/CommonInputText';
import React, { useState } from 'react';
import { changeFiscalDeviceUser, useAddOrEditFiscalDevice, useGetUsers } from '../utils/users-hooks';
import Select from 'react-select';
import { useAsyncResource } from 'use-async-resource';

export const AddEditFiscalDevice = ({ itemToEdit, setShowModal, refetchEntitiesHook }: AddEditProps<FiscalDeviceDTO>) => {
    const { t } = useTranslation('translation', { keyPrefix: 'table' });
    const { t: commonT } = useTranslation('translation', { keyPrefix: 'common' });
    const [getDistributors] = useAsyncResource(useGetUsers, undefined, 'DISTRIBUTOR,INSTALLER');
    const { items } = getDistributors();
    const getUser = () => items.find(({username}) => username === itemToEdit?.user);

    const [userId, setUserId] = useState<number | undefined>(getUser()?.id);

    const { register, handleSubmit, formState, watch, control } = useForm<FiscalDeviceDTO>({
        defaultValues: itemToEdit,
        mode: 'all',
    });

    const useSubmitHandler = async (formValue: FiscalDeviceDTO) => {
        const response = await useAddOrEditFiscalDevice({...formValue, user: getUser()});
        if (response && response.id) {
            await changeFiscalDeviceUser(response.id, userId);
        }
        refetchEntitiesHook();
        setShowModal(false);
    };

    return (
        <Form
            id='form'
            className='d-flex flex-column align-items-center p-4  w-100'
            noValidate
            onSubmit={handleSubmit(useSubmitHandler)}
        >
            <Form.Group className=' d-flex flex-column mb-3 align-items-start w-100 ' controlId='companyName'>
                <CommonInputText
                    id='serialNumber'
                    label={t('serialNumber')}
                    labelTextColor='text-black'
                    defaultValue={itemToEdit?.serialNumber}
                    type='text'
                    fieldError={formState.errors?.serialNumber}
                    hookRegister={register('serialNumber', {
                        required: {
                            value: true,
                            message: t('serialNumber'),
                        },
                    })}
                />
            </Form.Group>
            <Form.Group className=' d-flex flex-column mb-3 align-items-start w-100 ' controlId='companyName'>
                <CommonInputText
                    id='invoiceStartNumber'
                    label={t('invoiceStartNumber')}
                    labelTextColor='text-black'
                    defaultValue={itemToEdit?.invoiceStartNumber?.toString()}
                    type='text'
                    fieldError={formState.errors?.invoiceStartNumber}
                    hookRegister={register('invoiceStartNumber', {
                        required: {
                            value: true,
                            message: t('invoiceStartNumber'),
                        },
                    })}
                />
            </Form.Group>
            <Form.Group className=' d-flex flex-column mb-3 align-items-start w-100 ' controlId='companyName'>
                <CommonInputText
                    id='invoiceEndNumber'
                    label={t('invoiceEndNumber')}
                    labelTextColor='text-black'
                    defaultValue={itemToEdit?.invoiceEndNumber?.toString()}
                    type='text'
                    fieldError={formState.errors?.invoiceEndNumber}
                    hookRegister={register('invoiceEndNumber', {
                        required: {
                            value: true,
                            message: t('invoiceEndNumber'),
                        },
                    })}
                />
            </Form.Group>
            <Form.Group className=' d-flex flex-column mb-3 align-items-start w-100 ' controlId='companyName'>
                <CommonInputText
                    id='receiptStartNumber'
                    label={t('receiptStartNumber')}
                    labelTextColor='text-black'
                    defaultValue={itemToEdit?.receiptStartNumber?.toString()}
                    type='text'
                    fieldError={formState.errors?.receiptStartNumber}
                    hookRegister={register('receiptStartNumber', {
                        required: {
                            value: true,
                            message: t('receiptStartNumber'),
                        },
                    })}
                />
            </Form.Group>
            <Form.Group className=' d-flex flex-column mb-3 align-items-start w-100 ' controlId='companyName'>
                <CommonInputText
                    id='receiptEndNumber'
                    label={t('receiptEndNumber')}
                    labelTextColor='text-black'
                    defaultValue={itemToEdit?.receiptEndNumber?.toString()}
                    type='text'
                    fieldError={formState.errors?.receiptEndNumber}
                    hookRegister={register('receiptEndNumber', {
                        required: {
                            value: true,
                            message: t('receiptEndNumber'),
                        },
                    })}
                />
            </Form.Group>
            <Form.Group
                className='d-flex flex-column mb-3 align-items-start w-100'
                controlId='user'
            >
                <Form.Label>{t('user')}</Form.Label>
                <Controller
                    control={control}
                    name='user'
                    // rules={{ required: true }}
                    defaultValue={itemToEdit?.user}
                    render={({ field }) => (
                        <>
                            <Select
                                className='w-100'
                                defaultValue={getUser()}
                                onChange={(newValue) => {
                                    field.onChange(newValue);
                                    setUserId(newValue?.id ?? undefined);
                                }}
                                options={[{username: "-"} as User].concat(items) }
                                getOptionLabel={({ username }) => username}
                                getOptionValue={({ id }) => id ? id?.toString() : '-1'}
                            />
                        </>
                    )}
                />
            </Form.Group>
        </Form>
    );
};
